// extracted by mini-css-extract-plugin
export default {"root":"styles_root__U8X2F","ol":"styles_ol__c1oDi","typography":"styles_typography__rglUF","svgIcon":"styles_svgIcon__SV2ss","link":"styles_link__ZwTEa"};